export default __webpack_public_path__ + "static/media/FiraSans-MediumItalic.f7462ce9.woff2";